import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useClickAway } from 'react-use';

const initialState = {
  mouseX: null,
  mouseY: null
};

type ContextMenuItem = {
  text: string;
  action: () => void;
};

export default function ContextMenu(props: {
  items: ContextMenuItem[];
  isOpen: boolean;
  x: number;
  y: number;
  onClose: () => void;
}) {
  const ref = React.useRef(null);
  const { isOpen, items, onClose, x, y } = props;
  useClickAway(ref, () => {
    onClose();
  });

  return (
    <Menu
      ref={ref}
      keepMounted
      open={isOpen}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={{ top: y, left: x }}
    >
      {items.map(item => {
        return (
          <MenuItem
            key={item.text}
            onClick={e => {
              item.action();
              onClose();
              e.stopPropagation();
            }}
          >
            {item.text}
          </MenuItem>
        );
      })}
    </Menu>
  );
}
